/**
 * SPEC §4.2 — position, and what leaves the machine.
 *
 * The full-precision coordinate never outlives the truncation below. It is
 * not logged, not stored, not put in a request. THE SINGLE `encode(...)` CALL
 * IN THIS FILE IS THE PRIVACY BOUNDARY OF THE ENTIRE SYSTEM: everything past
 * it knows a ~4.9 km cell and nothing finer.
 */
import { COLLECTED_PRECISION, encode } from '@latency-globe/shared';

export type Located = { kind: 'cell'; cell: string } | { kind: 'denied' } | { kind: 'unavailable' };

export function geolocationAvailable(): boolean {
  return typeof navigator !== 'undefined' && 'geolocation' in navigator && window.isSecureContext;
}

export function locateCell(): Promise<Located> {
  if (!geolocationAvailable()) return Promise.resolve({ kind: 'unavailable' });
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve({ kind: 'cell', cell: encode(pos.coords.latitude, pos.coords.longitude, COLLECTED_PRECISION) }),
      (err) => resolve(err.code === err.PERMISSION_DENIED ? { kind: 'denied' } : { kind: 'unavailable' }),
      // Extra precision would be discarded by the truncation; asking for it costs battery.
      { enableHighAccuracy: false, timeout: 10_000, maximumAge: 600_000 },
    );
  });
}
